import React from "react";
import "./FabButton.css";
import add from '../../icons/add.svg';

function FabButton({ onClick }) {
    return (
        <>
            <button className="fab-button-movil" onClick={onClick}>
                <img src={add} alt="" />
            </button>
        </>
    )
}

export { FabButton }